module.exports = __webpack_public_path__ + "img/recipe.33ee5b5c.svg";